import React, { Component } from 'react'
import { bindActionCreators} from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import _ from 'lodash'
import {Breadcrumb, Segment, Form, Table, Input, Button, Label} from 'semantic-ui-react'
import {
    loadOrderById,
    updateOrderStatus
} from '../../actions/order'
import {
    setNewShipmentModel,
    updateShipmentHeaderInStoreByForm,
    updateShipmentLineQtyInStoreByForm,
    updateShipmentCommentInStoreByForm,
    createNewShipment
} from '../../actions/shipment'
import FormErrorMessage from "../utils/FormErrorMessage";
import CourierSelector from '../utils/searches/CourierSelector';
import RelationSearch from '../utils/searches/RelationSearch';
import Dls from '../../lib'

class MobileShipmentCreationPage extends Component {
    constructor() {
        super();
        this.state = {
            type: '',
            routeType: '',
            errors: [],
            loading: false,
            fulfillmentType: ''
        }
    }
    //access router
    //this.props.history.push('/dashboard')
    componentDidMount() {
        const {params} = this.props.match;
        if (_.isObject(params) && params.orderId) {
            if (parseInt(params.orderId) !== parseInt(this.props.order.id) || !this.props.order.id) {
                this.props.loadOrderById(this.props.jwt, params.orderId, 'None').then(res => {
                    this.props.setNewShipmentModel(res.data.data);
                    this.setPageRoutingState();
                }).catch(err => {});
            } else {
                this.props.setNewShipmentModel(this.props.order);
                this.setPageRoutingState();
            }
        } else {
            this.props.history.push('/');
        }
    }

    setPageRoutingState = () => {
        const {type} = this.props.order;
        let routeType = '/';
        let fulfillmentType = 'Outbound';
        if (type === 'Customer Order') {
            routeType = `customer-orders`;
        }
        if (type === 'Vendor Order') {
            routeType = `vendor-orders`;
            fulfillmentType = 'Inbound';
        }
        if (type === 'Customer Return') {
            routeType = `customer-returns`;
            fulfillmentType = 'Inbound';
        }
        if (type === 'Vendor Return') {
            routeType = `vendor-returns`;
            fulfillmentType = 'Outbound';
        }
        this.setState({
            routeType, type, fulfillmentType
        });
    }

    onLineQuantityChange = (line, value) => {
        this.props.updateShipmentLineQtyInStoreByForm(line.order_line_id, value);
    }
    
    onFormSubmit = () => {
        const {jwt, shipment, order} = this.props;
        const errors = this.validateInput();
        if (_.isEmpty(errors)) {
            this.setState({
                loading: true
            });
            this.props.createNewShipment(jwt, shipment, order.id).then(res => {
                this.props.history.replace(`/mobile/${this.state.routeType}/${order.id}/view`)
            }).catch(err => {
                const errors = Dls.apiErrorMessage(err);
                this.setState({
                    loading: false,
                    errors: errors
                });
            });
        } else {
            this.setState({
                errors: errors
            });
        }
    }

    validateInput = () => {
        const { header, lines } = this.props.shipment;
        const {warehouse_id, isDropShip, dropShipFrom} = header;
        const errors = [];
        if (!warehouse_id || _.isNaN(parseInt(warehouse_id))) {
            errors.push("Please select a warehouse");
        }
        if (isDropShip) {
            if (!dropShipFrom || _.isNaN(parseInt(dropShipFrom))) {
                errors.push("A vendor is required to create a drop ship");
            }
        }
        if (!_.isArray(lines)) {
            errors.push("A shipment requires at least one line item");
        }
        let totalQtyToProcess = 0;
        if (!isDropShip) {
            
        }
        lines.map((line, index) => {
            if (line.inventory.type === 'Inventory') {
                let qtyToProcess = parseInt(line.quantity);
                totalQtyToProcess = totalQtyToProcess + qtyToProcess;
                if (_.isNaN(qtyToProcess)) {
                    errors.push(`Line ${index + 1} has an invalid quantity`);
                } else {
                    if (!isDropShip) {
                        if (this.state.fulfillmentType === 'Outbound') {
                            if (qtyToProcess > this.getAvailable(line)) {
                                errors.push(`Line ${index + 1} does not have sufficient inventory to fulfill`);
                            }
                        }
                    }
                    if (qtyToProcess > (line.ordered - line.processed)) {
                        errors.push(`To many units to be fulfilled on line ${index + 1}`);
                    }
                }
            } else {
                let qtyToProcess = parseInt(line.quantity);
                totalQtyToProcess = totalQtyToProcess + qtyToProcess;
            }
        });
        if (totalQtyToProcess <= 0) {
            errors.push(`At least one unit is required to create a shipment`);
        }

        return errors;
    }

    getAvailable = (line) => {
        const warehouseId = this.props.shipment.header.warehouse_id;
        const {qty_warehouse_instock, qty_warehouse_reserved} = line.inventory;
        let reserved = 0;
        let instock = 0;
        if (_.isArray(qty_warehouse_instock)) {
            _.each(qty_warehouse_instock, instockRecord => {
                if (parseInt(warehouseId) === parseInt(instockRecord.warehouse_id)) {
                    instock = parseInt(instockRecord.instock);
                }
            });
        }
        if (_.isArray(qty_warehouse_reserved)) {
            _.each(qty_warehouse_reserved, reservedRecord => {
                if (parseInt(warehouseId) === parseInt(reservedRecord.warehouse_id)) {
                    reserved = Math.abs(_.toInteger(reservedRecord.reserve));
                }
            });
        }

        return instock - reserved;
    }

    render() {
        const {routeType, type, fulfillmentType} = this.state;
        const {order, shipment, warehouses, updateShipmentHeaderInStoreByForm, updateShipmentCommentInStoreByForm} = this.props;
        return (
            <div style={{padding: 3}}>
                <div className="row" style={{marginTop: 50}}>
                    <div className="col-xs-12">
                        <Breadcrumb size="huge">
                            <Breadcrumb.Section>
                                Orders
                            </Breadcrumb.Section>
                            <Breadcrumb.Divider />
                            <Breadcrumb.Section>
                                <Link
                                    to={`/${routeType}/${Dls.pagination.orders(type)}`}
                                >
                                    {type}s
                                </Link>
                            </Breadcrumb.Section>
                            <Breadcrumb.Divider />
                            <Breadcrumb.Section>
                                <Link to={`/${routeType}/${order.id}/view`}>
                                    {order.so}
                                </Link>
                            </Breadcrumb.Section>
                            <Breadcrumb.Divider />
                            <Breadcrumb.Section>
                                Create New Shipment
                            </Breadcrumb.Section>
                        </Breadcrumb>
                    </div>
                </div>
                <div className="row" style={{marginTop: '5px'}}>
                    <div className="col-xs-12">
                        <Form size='large'>
                            <Segment stacked>
                                {!_.isEmpty(this.state.errors) ? (
                                    <FormErrorMessage errors={this.state.errors} />
                                ) : null}
                                <div className="row">
                                    <div className="col-md-4 col-xs-12">
                                        <Form.Select fluid label='Warehouse' options={
                                            _.isArray(warehouses) ? warehouses : []
                                        } name="warehouse_id" value={shipment.header.warehouse_id ? _.toString(shipment.header.warehouse_id) : "0"} 
                                            onChange={(e,data) => { updateShipmentHeaderInStoreByForm('warehouse_id', data.value) }}
                                        />
                                    </div>
                                    <div className="col-md-4 col-xs-12">
                                        <CourierSelector 
                                            name="Courier"
                                            selectedValues={shipment.header.tracking_company ? shipment.header.tracking_company: ""}
                                            onValueChange={ (e,{value}) => {updateShipmentHeaderInStoreByForm('tracking_company', value) }}
                                        />
                                    </div>
                                    <div className="col-md-4 col-xs-12">
                                        <Form.Input 
                                            fluid 
                                            label="Tracking #"
                                            name="tracking_number"
                                            value={shipment.header.tracking_number ? shipment.header.tracking_number : ""} 
                                            onChange={(e) => { updateShipmentHeaderInStoreByForm(e.target.name, e.target.value) }}
                                        />
                                    </div>
                                    <div className="col-xs-12">
                                        <Form.TextArea
                                            label="Warehouse Note"
                                            name="comment"
                                            value={shipment.comment ? shipment.comment : ""} 
                                            onChange={(e, {value}) => { updateShipmentCommentInStoreByForm(e.target.value) }}
                                        />
                                    </div>
                                    <div className="col-xs-12" style={{marginTop: 15}}>
                                        {fulfillmentType === 'Outbound' ? <Form.Checkbox
                                            label="Create Drop Ship"
                                            name="isDropShip"
                                            onChange={(e,data) => { updateShipmentHeaderInStoreByForm('isDropShip', data.checked) }}
                                            checked={shipment.header.isDropShip}
                                        /> : null}
                                    </div>
                                </div>
                                {shipment.header.isDropShip ? 
                                    <div className="row" style={{marginTop: '10px'}}>
                                        <div className="col-xs-12">
                                            <RelationSearch
                                                jwt={this.props.jwt}
                                                name='Drop Ship From'
                                                selectedValues={shipment.header.dropShipFrom}
                                                placeHolder=""
                                                onValueChange={ (e, {value}) => { updateShipmentHeaderInStoreByForm('dropShipFrom', value) }}
                                                shouldAllowAll={false}
                                                relationType='Vendor'
                                            />
                                        </div>
                                    </div>
                                    : null}
                                <div className="row" style={{marginTop: '10px'}}>
                                    <div className="col-xs-12">
                                        <Table compact>
                                            {_.isArray(shipment.lines) ? <Table.Body>
                                                {shipment.lines.map (line => {
                                                    return (
                                                        <Table.Row key={line.order_line_id}>
                                                            <Table.Cell>SKU: {line.inventory.sku}</Table.Cell>
                                                            <Table.Cell>
                                                            {line.inventory.name} &nbsp;&nbsp;
                                                            {line.inventory.type !== 'Inventory' ? <Label size='tiny' color='purple'>{line.inventory.type}</Label> : null}
                                                            </Table.Cell>
                                                            <Table.Cell>Ordered: {line.ordered}</Table.Cell>
                                                            <Table.Cell>
                                                                Fulfilled: {line.inventory.type === 'Inventory' ? line.processed ? Math.abs(line.processed) : 0 : 'NA'}
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                To Fulfill: <Input value={line.quantity} size='mini' type="number"
                                                                    onChange={(e, {value}) => this.onLineQuantityChange(line, value) }/>
                                                            </Table.Cell>
                                                            <Table.Cell>Stock: {line.inventory.type === 'Inventory' ? this.getAvailable(line) : 'NA'}</Table.Cell>
                                                        </Table.Row>
                                                    );
                                                })}
                                            </Table.Body>: null}
                                        </Table>                                        
                                    </div>
                                </div>
                                <div className="row" style={{marginTop: '10px'}}>
                                    <div className="col-xs-12">
                                        <Button
                                            color="teal"
                                            size='mini'
                                            onClick={this.onFormSubmit}
                                            loading={this.state.loading}
                                            floated='right'
                                        >
                                            Create New Shipment
                                        </Button>
                                    </div>
                                </div>
                            </Segment>
                        </Form>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

MobileShipmentCreationPage.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    jwt: PropTypes.string.isRequired,
    order: PropTypes.object.isRequired,
    shipment: PropTypes.object.isRequired,
    setNewShipmentModel: PropTypes.func.isRequired,
    loadOrderById: PropTypes.func.isRequired,
    updateOrderStatus: PropTypes.func.isRequired,
    updateShipmentHeaderInStoreByForm: PropTypes.func.isRequired,
    updateShipmentLineQtyInStoreByForm: PropTypes.func.isRequired,
    updateShipmentCommentInStoreByForm: PropTypes.func.isRequired,
    createNewShipment: PropTypes.func.isRequired,
    warehouses: PropTypes.array.isRequired
};

function mapStateToProps(state) {
    return {
        order: state.order.model,
        shipment: state.shipment.model,
        jwt: state.auth.jwt,
        warehouses: state.system.resources.warehouses
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setNewShipmentModel,
        loadOrderById,
        updateOrderStatus,
        updateShipmentHeaderInStoreByForm,
        updateShipmentLineQtyInStoreByForm,
        updateShipmentCommentInStoreByForm,
        createNewShipment
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileShipmentCreationPage)


// WEBPACK FOOTER //
// ./src/components/mobile/MobileShipmentCreation.js